import { render, staticRenderFns } from "./ISPServiceAccounts.vue?vue&type=template&id=00d66250&"
import script from "./ISPServiceAccounts.vue?vue&type=script&lang=js&"
export * from "./ISPServiceAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports